import '../services.css';

const CustomWebSolution = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Custom Web Solution</h1> 
            </div>

            {/* Web Development Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                        <p className="text-justify">
                            Apart from standalone websites, we have also successfully established a variety of web portals, including product and service listings for a variety of domains such as matrimonial, education, employment, etc. Simply said, we have the skills and capacity to design almost any type of web portal you can think of - and we can do it quickly!
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets\images\service\custom.png"
                            alt="Custom Web Solution"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>
            {/* Additional Sections */}
            <div className="container py-2  ">
                <h3 className='mb-5'>HOW WE WORK TO SOLVE YOUR PROBLEMS!</h3>

                {/* UNDERSTANDING */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">UNDERSTANDING</h3>
                    <p className="text-justify">
                        It is important for us to understand present flaws and new requirements our clients may have while keeping the company type and it’s behaviour in mind in order to progress forward.
                    </p>
                </div>

                {/* BRAINSTORMING */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">BRAINSTORMING</h3>
                    <p className="text-justify">
                        Based on the knowledge, our team will assess the feasibility and challenges of every new problem that we face.
                    </p>
                </div>

                {/* SCOPE AND DESIGN */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">SCOPE AND DESIGN</h3>
                    <p className="text-justify">
                        The scope will be designed in such a way which will meet every client’s request while also checking for future enhancements to provide the customer with a forecast on his requirements.
                    </p>
                </div>

                {/* DEVELOPMENT */}
                <div className="mb-4">
                    <h3 className="h4 fw-semibold mb-3">DEVELOPMENT</h3>
                    <p className="text-justify">
                        We will make sure the product developed will meet your expectations and is delivered on time.
                    </p>
                </div>


                {/* TESTING AND DEPLOY */}
                <div className="mb-4">
                    <h3 className="h4 fw-semibold mb-3">TESTING AND DEPLOY</h3>
                    <p className="text-justify">
                        Every solution undergoes a minimum of Three-Level testing to verify that it addresses all aspects and we make sure that there are no errors involved.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default CustomWebSolution;
